// THIS FILE IS AUTO-GENERATED BY FIGMAGIC. DO NOT MAKE EDITS IN THIS FILE! CHANGES WILL GET OVER-WRITTEN BY ANY FURTHER PROCESSING.
const zIndices = {
    top: 100,
    focus: 10,
    higher: 2,
    high: 1,
    regular: 0,
};
module.exports = zIndices;
//# sourceMappingURL=zIndices.js.map